'use strict';

/*
 * h5yrEngagement.js -- reports the first time a visitor goes into the H5YR "Give a High 5" widget
 * (Views/Partials/H5yrWidget.cshtml; specs/005-video-library, FR-051, research R14, contracts/analytics-events.md).
 *
 * The widget is a cross-origin iframe that never posts to the parent page, so a real High 5 can't be seen. What
 * can be seen is focus moving into the frame: `document.activeElement` becomes the widget's iframe.
 *
 * - From the page: the window blurs. activeElement is read a tick later, because some browsers only move it after
 *   the blur event.
 * - From another iframe, typically the YouTube player after pressing play: the window is already blurred, and focus
 *   moving between two child frames fires no event in this document at all. So while focus sits in another iframe,
 *   activeElement is polled until it becomes the widget or focus comes back to the page (window `focus`).
 *
 * init(onEngage) calls onEngage once per page view; the page decides what to send. Video watch pages send GA4
 * `h5yr_engage` {video_id, video_title} and Engage "Video" / "High 5 widget" / video_id (videopage.js); blog posts
 * send GA4 `h5yr_engage` {post_title} and Engage "Blog" / "High 5 widget" / the post's path (blog.js).
 */

var POLL_MS = 400;

var sent = false;
var poll = null;
var onEngage = null;

function isWidgetFrame(el) {
    return !!(el && el.tagName === 'IFRAME' && el.closest && el.closest('.h5yr-widget'));
}

function stopPolling() {
    if (poll !== null) {
        window.clearInterval(poll);
        poll = null;
    }
}

function report() {
    sent = true;
    stopPolling();
    window.removeEventListener('blur', onBlur);
    window.removeEventListener('focus', stopPolling);

    onEngage();
}

function check() {
    var active = document.activeElement;
    if (sent) {
        return;
    }
    if (isWidgetFrame(active)) {
        report();
    } else if (!active || active.tagName !== 'IFRAME') {
        stopPolling(); // focus is back in this document
    }
}

function onBlur() {
    window.setTimeout(function () {
        check();
        if (!sent && poll === null && document.activeElement && document.activeElement.tagName === 'IFRAME') {
            poll = window.setInterval(check, POLL_MS);
        }
    }, 0);
}

function init(callback) {
    if (document.querySelector('.h5yr-widget iframe')) {
        onEngage = callback;
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', stopPolling);
    }
}

module.exports = { init: init };
